import React from "react";
import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../assets/css/BreadcrumbStyle.css";
import { formatBreadcrumbName } from "../../utils/breadcrumb.utils";

const Breadcrumb = ({ items = [] }) => {
  return (
    <div className="bg-gray-50 py-3 top-box-margin">
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li>
              <Link
                to="/"
                className="text-gray-700 text-decoration-none"
                >
                Home
              </Link>
            </li>

            {items.map((item, index) => {
              const isLast = index === items.length - 1;

              return (
                <li
                  key={index}
                  className={`${isLast ? "active" : ""}`}
                  aria-current={isLast ? "page" : undefined}
                >
                  <span className="breadcrumb-icon" style={{ margin:"0 5px"}}>
                    <i className="bi bi-chevron-right"></i>
                  </span>

                  {isLast ? (
                    <span>{formatBreadcrumbName(item.name)}</span>
                  ) : (
                    <Link
                      to={item.path}
                      className="text-gray-700 text-decoration-none"
                    >
                      {formatBreadcrumbName(item.name)}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumb;